import type { PublishedProject } from "./types";

/** Returns the deterministic portfolio presentation order: stable overviews newest-first, followed by explicitly ordered README exceptions. */
export function sortProjectsForPortfolio(
  projects: readonly PublishedProject[],
): PublishedProject[] {
  return [...projects].sort((left, right) => {
    if (
      left.sourceType === "public-overview" &&
      right.sourceType === "public-overview"
    ) {
      const releaseOrder = right.releaseDate.localeCompare(left.releaseDate);
      if (releaseOrder !== 0) {
        return releaseOrder;
      }

      const titleOrder = left.title.localeCompare(right.title);
      return titleOrder !== 0 ? titleOrder : left.id.localeCompare(right.id);
    }

    if (left.sourceType === "public-overview") {
      return -1;
    }
    if (right.sourceType === "public-overview") {
      return 1;
    }

    const orderDifference =
      (left.displayOrder ?? Number.MAX_SAFE_INTEGER) -
      (right.displayOrder ?? Number.MAX_SAFE_INTEGER);

    if (orderDifference !== 0) {
      return orderDifference;
    }

    const titleOrder = left.title.localeCompare(right.title);
    return titleOrder !== 0 ? titleOrder : left.id.localeCompare(right.id);
  });
}
